import { FormGroup, Label, Form, Col, Row, Card,Button,ModalBody,Modal,ModalHeader,ModalFooter } from "reactstrap"
import { useForm } from "react-hook-form";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useEffect, useState } from "react";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";


const EmailSender = () => {
    const { register, formState: { errors }, handleSubmit, setValue } = useForm()
    const [showModal, setShowModal] = useState(false);

    useEffect(()=>{
          const getDefaultValue = async ()=>{
             try{
                 const response = await ApiService.axiosApi(`/emailsender/getdefaultemail`,{
                     method:'GET'

                 })
                 if(response.success){
                     setValue("FromEmailAddress",response.data._defaultSmtpUserName);
                     setValue("Password",response.data._defaultSmtpPassword);
                     setValue("Smtp",response.data._defaultSmtpServer);
                     setValue("Port",response.data._defaultSmtpPort);
                     setValue("EnableSsl",response.data._defaultEnableSsl);
                 }else{ 
                    console.log("unable to get email")
                 }
             }catch(error){

                 console.log(error)
             }
          }

          getDefaultValue();
    },[])
      const onEmailSend = async (data:any)=>{

        try{
             const response = await ApiService.axiosApi(`emailsender/addemailsender`,{
                 method:'POST',
                 data:data,
             })
             if(response.success){
                 toast.success(response.message||"email sent successfully")
             }else{
                toast.error("unable to send email ")
             }
        }catch(error){
            console.log(error)
        }
          
      }
    return (

        <>
        <Col xl={12} className="mx-auto py-3">
        <Card >
             <CommonCardHeader title="Email Sender" headClass="pb-3" />
            <Form onSubmit={(e:any)=>{
                  e.preventDefault();
                  setShowModal(true)
            }} className="p-3">

                <Row className="mb-3">
                    <Col md={6}>
                <FormGroup>
                    <Label className="col-form-label">Email Address</Label>
                    <input
                        className="form-control"
                        type="email"
                        {...register("FromEmailAddress", {
                            required: "Email is required",
                            
                        })}
                    />
                    {errors.Email&& <p className="text-danger mt-1">{errors.Email.message?.toString()}</p>}
                </FormGroup>
                </Col>
                <Col md={6}>
                <FormGroup>
                    <Label className="col-form-label">Password</Label>
                    <input
                        className="form-control"
                        type="Password"
                        {...register("Password", {
                            required: "Password is required",
                           
                        })}
                    />
                    {errors.Password && <p className="text-danger mt-1">{errors.Password.message?.toString()}</p>}
                </FormGroup>
                </Col>
                </Row>
                

                <Row className="mb-3">
                    <Col md={6}>
                        <FormGroup>
                            <Label className="col-form-label">SMTP Server</Label>
                            <input
                                className="form-control"
                                type="text"
                                {...register("Smtp", {
                                    required: "SMTP Server is required",
                                    
                                })}
                            />
                            {errors.SmtpServer && (
                                <p className="text-danger mt-1">
                                    {errors.SmtpServer.message?.toString()}
                                </p>
                            )}
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Label className="col-form-label">Port</Label>
                            <input
                                className="form-control"
                                type="number"

                                {...register("Port", {
                                    required: "Port is required",
                                   
                                })}
                            />
                            {errors.Port && (
                                <p className="text-danger mt-1">
                                    {errors.Port.message?.toString()}
                                </p>
                            )}
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                <Col md={6}>
                        <FormGroup>
                            <Label className="col-form-label">Enable SSL</Label>
                            <input
                                className="form-control"
                                type="text"

                                {...register("EnableSsl", {
                                    required: "SSL is required",
                                   
                                })}
                            />
                            {errors.Ssl&& (
                                <p className="text-danger mt-1">
                                    {errors.Ssl.message?.toString()}
                                </p>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
                <div className="form-group mb-3 mx-3">
              <div className="d-flex justify-content-start">
              <Button color="primary me-2" onClick={()=>  {setValue("FromEmailAddress",'')
                     setValue("Password",'')
                     setValue("Smtp",'')
                     setValue("Port",'')
                     setValue("EnableSsl",'')}} >
                Edit
                </Button>
                <Button color="info" type="submit">
                 Test
                </Button>
                
              </div>
            </div>
            </Form>
            

            <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
        <Form onSubmit={handleSubmit(onEmailSend)}>
          <ModalHeader>To Email</ModalHeader>
          <ModalBody>
            <Label>To Email:</Label>
            <input
            className=""
             style={{width:'300px',marginLeft:'10PX',height:'33px',borderRadius:'5px',border:'1px solid grey'}} 
            {...register("ToEmail")}  />
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary" onClick={() => setShowModal(false)}>
              Confirm
            </Button>
            <Button type="button" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
            </Card>
            </Col>
        </>
    )
}
export default EmailSender;